import Immutable from 'immutable';
import {
  selectEnrolledCoursePathList,
  selectFiltersForFeed,
} from '../Courses/CourseFeed/selectors';
import {
  SET_SELECTED_FEED_FILTER,
  SET_FEED_FILTER_BY_COURSE_PROGRESS,
  RESET_FEED_FILTER_BY_COURSE_PROGRESS,
  CLEAR_LAST_ACCESSED_COURSE,
} from './actions';
import { UPDATE_LAST_ACCESSED_COURSE } from '../Courses/LastAccessedCourse/actions';
import { lastAccessedCourseSelector } from '../Courses/LastAccessedCourse/selectors';
import { currentUserEnrolmentsByCourseSelector } from '../Enrolments/selectors';
import { navigateToActivityFeed } from '../Navigation/dispatchers';

export function applyFeedFilter(course) {
  return (dispatch, getState) => {
    const currentUserEnrolments = currentUserEnrolmentsByCourseSelector(
      getState()
    );
    const enrolledCourse = currentUserEnrolments
      .get(course.get('coursePath'))
      .first();
    dispatch({
      type: UPDATE_LAST_ACCESSED_COURSE,
      course,
    });
    dispatch({
      type: SET_SELECTED_FEED_FILTER,
      name: course.get('cohortName'),
      coursePath: course.get('coursePath'),
      cohortPath: enrolledCourse.get('cohortPath'),
      themeColor: course.get('cohortThemeColor'),
      institution: course.get('institution'),
    });

    dispatch(navigateToActivityFeed(course.get('coursePath')));
  };
}

export function initializeFilterForFeed() {
  return (dispatch, getState) => {
    // applied feed filter
    const cohortsByCourseCreator = selectFiltersForFeed(getState());
    const lastAccessedCourseData = lastAccessedCourseSelector(getState());
    const enrolledCourseList = selectEnrolledCoursePathList(getState());
    const lastAccessedCourse = lastAccessedCourseData.get('course');

    if (
      cohortsByCourseCreator.has('cohortsList') &&
      cohortsByCourseCreator.get('cohortsList').size > 0
    ) {
      // check if user have last accessed course or not
      if (
        lastAccessedCourse !== Immutable.Map() &&
        enrolledCourseList
          .get('coursePathList')
          .includes(lastAccessedCourse.get('coursePath'))
      ) {
        dispatch(applyFeedFilter(lastAccessedCourse));
      } else {
        dispatch(
          applyFeedFilter(cohortsByCourseCreator.get('cohortsList').get(1))
        );
      }
    } else {
      dispatch({ type: CLEAR_LAST_ACCESSED_COURSE });
    }
  };
}

export function applyFeedFilterByCourseProgress(course) {
  return {
    type: SET_FEED_FILTER_BY_COURSE_PROGRESS,
    cohortName: course.get('cohortName'),
    coursePath: course.get('coursePath'),
    cohortPath: course.get('cohortPath'),
    cohortThemeColor: course.get('cohortThemeColor'),
    institution: course.get('institution'),
  };
}

export function resetFeedFilterByCourseProgress() {
  return {
    type: RESET_FEED_FILTER_BY_COURSE_PROGRESS,
  };
}
